import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { PushDeviceEntry } from '@tourfold/libraries/tf-api-client-frontend-v2';
import { TestLogEntry } from './test-log-entry';

@Component({
  selector: 'tf-settings-test-push-dialog',
  imports: [CommonModule, DialogModule, ButtonModule, TranslateModule],
  templateUrl: './test-push-dialog.html',
  styleUrl: './test-push-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestPushDialog {
  readonly visible = input<boolean>(false);
  readonly device = input<PushDeviceEntry | null>(null);
  readonly logEntries = input<TestLogEntry[]>([]);
  readonly testInProgress = input<boolean>(false);

  readonly visibleChange = output<boolean>();
  readonly send = output<void>();

  onVisibleChange(visible: boolean): void {
    this.visibleChange.emit(visible);
  }

  onClose(): void {
    this.visibleChange.emit(false);
  }

  onSend(): void {
    if (!this.testInProgress()) {
      this.send.emit();
    }
  }

  getPlatformIcon(platform: string | undefined): string {
    if (platform === 'IOS') return 'pi pi-apple';
    if (platform === 'ANDROID') return 'pi pi-android';
    return 'pi pi-mobile';
  }

  getPlatformLabelKey(platform: string | undefined): string {
    if (platform === 'IOS') return 'SETTINGS.PUSH_NOTIFICATIONS.PLATFORM_IOS';
    if (platform === 'ANDROID') return 'SETTINGS.PUSH_NOTIFICATIONS.PLATFORM_ANDROID';
    return 'SETTINGS.PUSH_NOTIFICATIONS.PLATFORM_UNKNOWN';
  }
}
